<template>
	<div class="seomain">
		<st-header
		  title="订单详情"
		  :back-able="true"
			:close-able="true"
		>
		  <template slot="header-right">
				<span>
				  <!-- 更多 -->
				</span>
		  </template>
		</st-header>
		
		<div class="tab-content" v-loading="loading">
			<van-tabs v-model="active" scrollspy sticky offset-top="40px">
			  <van-tab v-for="(tab, i) in tabs" :title="tab.title">
			    
					<detail-purchase
						v-if="tab.comp == 'purchase'"
						:id="id"
					>
					</detail-purchase>
					<detail-receive
						v-else-if="tab.comp == 'receive'"
						:code="info.ordercode"
					>
					</detail-receive>
					<detail-out
						v-else-if="tab.comp == 'out'"
						:id="id"
					>
					</detail-out>
					<detail-send
						v-else-if="tab.comp == 'send'"
						:id="id"
					>
					</detail-send>
					<detail-info :id="id" v-else></detail-info>
			  </van-tab>
			</van-tabs>
			
			
		</div>
	</div>
</template>

<script>
	import StHeader from "@/components/layout/Header.vue";
	import detailInfo from "@/views/Sto/saleo/components/detail/info.vue";
	import detailPurchase from "@/views/Sto/saleo/components/detail/purchase.vue";
	import detailOut from "@/views/Sto/saleo/components/detail/out.vue";
	import detailReceive from "@/views/Sto/saleo/components/detail/receive";
	import detailSend from "@/views/Sto/saleo/components/detail/send.vue";
	export default {
		components: {
			"st-header": StHeader,
			"detail-info": detailInfo,
			"detail-purchase": detailPurchase,
			"detail-out": detailOut,
			"detail-receive": detailReceive,
			"detail-send": detailSend,
		},
		props: {},
		data() {
		  return {
				active: '',
				id: '',
		    stlist: [],
				loading: false,
				info: {},
				tabs: [
					{ title: '订单详情', comp: "info" },
					{ title: '关联采购单', comp: "purchase" },
					{ title: '收款记录', comp: "receive" },
					{ title: '出库记录', comp: "out" },
					{ title: '发货记录', comp: "send" }
				],
		  };
		},
		watch: {},
		created() {
		  this.init();
		},
		mounted() {},
		methods: {
		  init() {
				this.id = this.$route.params['id'];
				this.getDetail();
			},
			// 获取详情
			getDetail() {
				this.loading = true;
				this.$post(this.$api.stGetXiaoshouoDetail, {id: this.id}).then((res) => {
					if (res.code == 200) {
						this.info = res.data;
						this.stlist = res.data.skus;
					} else {
						this.$toast.fail(res['msg'] ? res['msg'] : '请求异常');
					}
					this.loading = false;
				})
			},
		},
	}
</script>

<style lang="scss" scoped>
	div {
		box-sizing: border-box;
	}
	.st-list-box{
		margin: 12px 24px;
		::v-deep .st-list {
			padding: 0px;
			border-radius: 5px;
			.st-list-top {
				width: 100%;
				display: flex;
				justify-content: space-between;
				background-color: rgb(103, 117, 138);
				color: white;
				padding: 12px 24px;
			}
			.st-list-main {
				padding: 12px 24px;
			}
		}
	}
	
	.tab-content {
		padding-bottom: 16px;
	}
	
	/* 2行input start */
	.tab-content-list {
	  padding-top: 0px;
		position: relative;
		top:50px;
	}
	
	.pan-3 .t-tit {
	  border-left: 3px solid #ff5733;
	}
	
	.st-list-bottom-diy {
	  display: flex;
	}
	.st-list-bottom-diy .st-diyl-btn {
	  background: #677588;
	  border-radius: 5px;
	  flex: 1;
	  margin-right: 8px;
	}
	.st-list-bottom-diy .st-diyr-btn {
	  background: #00baad;
	  border-radius: 5px;
	  flex: 1;
	  margin-left: 8px;
	}
</style>